import { useContext } from "react";

import {
  LocaleContext,
  LocaleContextProps,
} from "src/internationalization/locale/LocaleProvider.tsx";

export const useLocale = (): LocaleContextProps => {
  return useContext(LocaleContext);
};
